/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from 'react';

export default class extends Component{
    render() {
        const pub = this.props.publicidad;
        return (
            <a href={pub.url} target="_blank" rel="noopener noreferrer">
                <div className="poi-info pub-info media">
                    <div className="media-left">
                        <div className="thumbnail">
                            <img src={pub.imagen.url} alt=""/>
                        </div>
                    </div>
                    <div className="media-body">
                        <h4 className="media-heading">{pub.titulo}</h4>
                        <p>{pub.texto}</p>
                    </div>
                    <div id="indicador">Publicidad</div>
                </div>
            </a>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Publicidad.js